import React from 'react';
import ZapayIcon from './zapay.png';

export const HomePageZapayLogo = () => {
  return <img src={ZapayIcon} height='200px' />;
};